import * as React from 'react';
import styled from 'styled-components';

import { ButtonProps } from 'components/Button';

import ContactsSearch, { ContactsSearchProps } from './ContactsSearch';
import AddContactButton from './AddContactButton';

interface ContactsHeaderExtrasProps {
  onSearchChange?: ContactsSearchProps['onChange'];
  onAddContactClick?: ButtonProps['onClick'];
  searching?: ContactsSearchProps['loading'];
}

const ContactsHeaderExtras: React.FC<ContactsHeaderExtrasProps> = ({
  onSearchChange,
  onAddContactClick,
  searching,
}) => (
    <StyledExtrasWrapper>
      <ContactsSearch onChange={onSearchChange} loading={searching} />
      <StyledSpacer />
      <AddContactButton onClick={onAddContactClick} />
    </StyledExtrasWrapper>
  );

export default ContactsHeaderExtras;

const StyledExtrasWrapper = styled.div`
  display: flex;
  flex: 1 1 100%;
  justify-content: flex-end;
`;

const StyledSpacer = styled.div`
  width: 16px;
`;
